export default "__VITE_ASSET__4vfTjm7D__"